const batteryShippingFormAgreementMd = `
## 〜【補充専用】 バッテリーの発送〜

※補充禁止バッテリーの発送は[こちら](https://spotwork.biz/reports/battery_shipping_form)

※補充禁止と補充用という区分がわからない方は[こちら](https://docs.google.com/presentation/d/1Wp_IbgAf9a5u-twzp9eL1qlj_4siU_YUXwHFtUoe5lg/edit#slide=id.p15)

<br>

------

### ■対象バッテリー
・補充に使えるバッテリー<br> ※補充に使えるバッテリーは、補充しても、倉庫に送ってもどちらでも報酬に変えることができます。

### ■報酬
・税込60 円（税抜54.5円）/個

### ■発送方法
・郵送（追跡番号付き）

### ■郵送の詳細
差出氏名：【SpotWORK＋氏名】としてください

発送方法：追跡番号つきであること

梱包方法：段ボール

品名　　：モバイルバッテリー（のみの記載でOK）

送料負担：元払い限定（送料は報酬に含まれる）

発送住所：<br>〒350-1221 日高市下大谷沢85-1<br> 日本トータルテレマーケティング内<br>INFORICH配送センター宛

### ■注意点
・補充禁止バッテリーと補充用バッテリーは一緒に送れません<br>→送り先が異なります
・着払いは受け取れません

------
<br>
  `
  export { batteryShippingFormAgreementMd }